<template>
  <div class="card-item" :id="id" @click="click">
    <div class="card-item__inner">
      <div class="card-face front" v-html="cardItemText" v-show="isCard"></div>
      <ul class="card-face back" :class="selectedSpecialCard ? 'active' : ''">
        <li class="card-special-title" v-show="selectedSpecialCard"><img src="../assets/image/txt_crispr_cas_small.png" alt=""></li>
        <li v-for="(item, index) in cardItemData" :class="index">
          <span v-if="item !== ''">{{ textDNA[index] }}</span>
          <span v-if="item !== ''">{{item}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  import { store } from '../store/store'
  import 'gsap'
  export default {
    name: 'CardItem',
    props: ['id', 'itemCard'],
    data () {
      return {
        msg: 'This is CardItem',
        colorBackground: ['#cc00cc', '#ffcc00', '#00cc00', '#0033cc'],
        count: -1,
        timeLine: -1,
        textDNA: {
          speed: 'スピード',
          stamina: 'スタミナ',
          brave: 'コンジョウ',
          calm: 'オチツキ',
          health: 'ケンコウ',
          sex: '性染色体'
        }
      }
    },
    created () {
      // console.log('card-item-created')
      // console.log(this.itemCard)
      this.animateCard()
    },
    mounted () {
      // console.log('this.itemCard', this.itemCard)
    },
    computed: {
      currentScreen () {
        return store.state.currentScreen
      },
      currentSufferCard () {
        this.msg = store.state.sufferCard
        return store.state.sufferCard
      },
      colorBackgroundD () {
        if (this.id === 'A1' || this.id === 'C2') {
          return ['#cc00cc', '#ffcc00', '#00cc00', '#0033cc']
        } else if (this.id === 'B1' || this.id === 'D2') {
          return ['#ffcc00', '#00cc00', '#0033cc', '#cc00cc']
        } else if (this.id === 'C1' || this.id === 'A2') {
          return ['#00cc00', '#0033cc', '#cc00cc', '#ffcc00']
        } else if (this.id === 'D1' || this.id === 'B2') {
          return ['#0033cc', '#cc00cc', '#ffcc00', '#00cc00']
        }
      },
      cardItemText () {
        return this.currentScreen !== 'specialCard' ? '' : (this.id === 'A1' || this.id === 'A2' ? '' : 'えらべません')
      },
      isStop () {
        return store.state.isStopSufferCard
      },
      isCard () {
        return this.currentScreen !== 'specialCard' || (this.currentScreen === 'specialCard' && this.id !== 'A1' && this.id !== 'A2')
      },
      adnSpecial () {
        return store.state.adnSpecial
      },
      cardItemData () {
        if (this.currentScreen === 'specialCard') {
          let temp = !_.isEmpty(store.state.arraySpecialDNA) ? _.clone(store.state.arraySpecialDNA[this.id]) : _.clone(this.itemCard)
          return temp
        } else {
          return _.clone(this.itemCard)
        }
      },
      selectedSpecialCard () {
        return store.state.adnSpecial !== -1 && this.id === store.state.adnSpecial && this.currentScreen === 'specialCard'
      },
      resetStatus () {
        return store.state.resetStatus
      }
    },
    methods: {
      onRepeat () {
        this.count = this.count === 3 ? 0 : this.count + 1
        TweenMax.to('#' + this.id + ' .front', 0.2, {backgroundColor: this.colorBackgroundD[this.count], ease: Power1.easeOut})
      },
      animateCard () {
        this.timeLine = -1
        this.timeLine = new TimelineMax()
        let tm = TweenMax.to('#' + this.id + ' .front', 0.4,
          {repeat: -1, onRepeat: this.onRepeat, repeatDelay: 0.4, ease: Linear.easeNone})
        this.timeLine.append(tm)
        this.timeLine.pause()
      },
      click (e) {
        this.$emit('click', e)
      }
      // setCardItemData: function () {
      //   this.cardItemData = _.clone(this.itemCard)
      // }
    },
    watch: {
      currentSufferCard (val) {
//        console.log('currentSufferCard', val)
        if (val) {
          this.timeLine.pause(0)
          this.timeLine = -1
        } else {
          this.animateCard()
          this.timeLine.play()
        }
      },
      resetStatus (val) {
        if (val) {
          this.timeLine.pause()
          this.timeLine.kill()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CardItem.vue?fbb5d414